import React, { useState } from 'react'
import Parse from 'parse'
import PropTypes from 'prop-types'

const HISTORICAL_PERMISSION = 'HISTORICAL_DATA_EXPORT'
const DAYS_PER_YEAR = 365
const YEAR_OPTIONS = [1, 2, 3, 5]
const DEFAULT_YEARS = 5

export function formatBackfillResult (result) {
  const windows = result.requested + result.alreadyRequested
  return `Asked Garmin for ${result.days} days of history ` +
    `(${result.requested} of ${windows} windows new, ` +
    `${result.alreadyRequested} already requested). ` +
    'Swims arrive over the next few hours; non-swims and duplicates ' +
    'are skipped.'
}

// Garmin rejects a backfill until the member grants historical access.
export function isMissingHistoricalPermission (permissions) {
  return Array.isArray(permissions) &&
    !permissions.includes(HISTORICAL_PERMISSION)
}

function GarminHistoryBackfillComponent ({ memberId, garminPermissions }) {
  const [years, setYears] = useState(DEFAULT_YEARS)
  const [isRequesting, setIsRequesting] = useState(false)
  const missingPermission = isMissingHistoricalPermission(garminPermissions)

  const handleYearsChange = (event) => {
    setYears(Number(event.target.value))
  }

  const handleBackfill = async (event) => {
    event.preventDefault()
    const question = `Import the last ${years} year(s) of this member's ` +
      'Garmin swims? New swims are logged to their account.'
    if (!window.confirm(question)) {
      return
    }

    setIsRequesting(true)
    try {
      const result = await Parse.Cloud.run('requestGarminHistoryBackfill', {
        userId: memberId,
        days: years * DAYS_PER_YEAR
      })
      window.alert(formatBackfillResult(result))
    } catch (error) {
      window.alert('Could not request Garmin history: ' + error.message)
    } finally {
      setIsRequesting(false)
    }
  }

  return (
    <div className="mt-2">
      <b>Garmin history</b>
      <div className="input-group input-group-sm">
        <select
          className="form-select"
          value={years}
          onChange={handleYearsChange}
          disabled={isRequesting || missingPermission}
        >
          {YEAR_OPTIONS.map((option) => (
            <option key={option} value={option}>
              {option === 1 ? '1 year' : `${option} years`}
            </option>
          ))}
        </select>
        <button
          className="btn btn-outline-secondary"
          onClick={handleBackfill}
          disabled={isRequesting || missingPermission}
          title="Asks Garmin to re-send this member's past activities."
        >
          {isRequesting ? 'Requesting...' : 'Import from Garmin'}
        </button>
      </div>
      {missingPermission && (
        <small className="text-muted">
          Member must reconnect Garmin and allow historical data.
        </small>
      )}
    </div>
  )
}

GarminHistoryBackfillComponent.propTypes = {
  memberId: PropTypes.string.isRequired,
  garminPermissions: PropTypes.arrayOf(PropTypes.string)
}

export default GarminHistoryBackfillComponent
